import { queryOptions } from '@tanstack/react-query'
import { getExpense } from 'src/queries/expenses/expenses.network'
import { expensesQueryKeys } from 'src/queries/queries.constants'

export const expenseQueries = {
  /**
   * OOPE single expense detail. enabled-guards on expenseId so an undefined
   * route param never builds /expenses/undefined. retry:false preserves the
   * legacy `getExpense` thunk's single-attempt behavior (the consumer gates a
   * failed read straight to NotFound).
   */
  detail: (expenseId: string | undefined) =>
    queryOptions({
      queryKey: expensesQueryKeys.detail(expenseId),
      queryFn: () => getExpense(expenseId!),
      enabled: expenseId !== undefined,
      retry: false,
    }),
}
